import BaseApi from '../baseApi';

export default class SketchApi extends BaseApi {
  constructor(obj){
      obj = obj || {};
      super(obj);
  }

  add(skecth) {
    skecth = skecth || {};

    return new Promise((resolve, reject) => {
      return this.api
        .post('/sketches', skecth)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  find(filters) {
    return new Promise((resolve, reject) => {
      return this.api
        .get('/sketches/', { params: filters })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  update(id, sketch) {
    sketch = sketch || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/sketches/${id}`, sketch)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findId(id) {
    id = id || {};

    return new Promise((resolve, reject) => {
      return this.api
        .get(`/sketches/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  remove(id) {
    id = id || {};

    return new Promise((resolve, reject) => {
      return this.api
        .delete(`/sketches/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
}
